import axiosInstance from '@/utils/api.js'

var state = {
  totalBonus: 0
}

var getters = {
  TOTAL_BONUS: (state) => {
    return state.totalBonus
  }
}

var mutations = {
  SET_TOTAL_BONUS: (state, payload) => {
    state.totalBonus = payload
  }
}

var actions = {
  GET_TOTAL_BONUS: async (context, payload) => {
    let result = await axiosInstance.get('/users/total_bonus?user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_TOTAL_BONUS', result.data.total)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/bonuses.js